import { FC } from 'react';

import { useTranslate } from 'hooks/useTranslate';
import { usePartnerOperations } from '../context/PartnerOperationsContext';

const DividendsSectionHeader: FC = () => {
  const { t } = useTranslate();

  const { data } = usePartnerOperations();

  return (
    <div className="nk-block-head mt-5" id="dividends-table">
      <div className="nk-block-head-content">
        <h4 className="nk-block-title">{t('Dividends')}</h4>
        <div className="nk-block-des">
          <p>
            {t('DividendsDetails', {
              societyName: data.societyName,
            })}
          </p>
        </div>
      </div>
    </div>
  );
};

export default DividendsSectionHeader;
